import React from 'react';
import { StarFilled, StarOutlined } from '@ant-design/icons';

/**
 * بک‌اند CRM: مقدار عددی اولویت همان تعداد ستاره است (1/2/3).
 * high/medium/low برای سازگاری با فیلترهای قدیمی نگه‌داری می‌شود.
 */
const filledCountForPriority = (priority) => {
  if (priority === 'high') return 1;
  if (priority === 'medium') return 2;
  if (priority === 'low') return 3;
  const level = Number(priority);
  if (level >= 1 && level <= 3) return level;
  return 0;
};

const priorityForStarCount = (count) => {
  if (count >= 1 && count <= 3) return count;
  return null;
};

const PriorityStars = ({ priority, value, onChange, size = 12, className = '', disabled = false }) => {
  const actualPriority = value ?? priority;
  const filled = filledCountForPriority(actualPriority);
  const interactive = typeof onChange === 'function';
  if (!filled && !interactive) return null;

  return (
    <span
      className={`inline-flex items-center gap-0.5 flex-shrink-0 ${disabled ? 'opacity-70' : ''} ${className}`}
      onClick={(e) => e.stopPropagation()}
      role="img"
      aria-label={`اولویت ${filled} از ۳`}
    >
      {[1, 2, 3].map((i) => {
        const Icon = i <= filled ? StarFilled : StarOutlined;
        return (
          <Icon
            key={i}
            onClick={(e) => {
              e.stopPropagation();
              if (!interactive || disabled) return;
              onChange(priorityForStarCount(i));
            }}
            style={{
              fontSize: size,
              color: i <= filled ? '#fadb14' : '#bfbfbf',
              cursor: interactive && !disabled ? 'pointer' : 'default',
              filter: i <= filled ? 'drop-shadow(0 1px 1px rgba(250, 173, 20, 0.35))' : 'none',
              transition: 'color 0.15s, transform 0.15s, filter 0.15s',
            }}
            className={interactive && !disabled ? 'hover:scale-125 active:scale-95' : ''}
          />
        );
      })}
    </span>
  );
};

export default PriorityStars;
